import { object } from 'common/helpers'


export const initialState = {
  products: {},
  isFetching: false,
  selectedItems: [],
}

export const selectItem = (state, payload /* payload = item.id */) => (
  object.update(state, 'selectedItems', (selectedItems) => {
    const newSelectedItems = selectedItems.slice()
    newSelectedItems.push(payload)
    return newSelectedItems
  })
)

export const setProducts = (state, payload) => (
  object.set(state, 'products', payload)
)

export const setSelectedItems = (state, payload) => (
  object.set(state, 'selectedItems', payload)
)

export const clearItems = (state) => (
  object.set(state, 'selectedItems', [])
)
